/*
 *   File : banner.js
 *   Author : https://evoqins.com
 *   Description : Banner card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';

// Custom component
import { SecondaryButton, TextButton } from '../Buttons';
import { Icon } from '../Icon';
import moment from 'moment';

const BannerCard = (props) => {

    return (
        <div className="row">
            <div className='col-4'>
                <img src={props.data.image}
                    draggable={false}
                    className='w-100 e-border-radius-24'
                    height={138}
                    alt="card-img" />
            </div>

            <div className="col-7">
                {props.data.type_id === 1 ?
                    <>
                        <p className='mb-3 e-alt-font-noto-sans e-text-raisin-black e-font-14 e-font-weight-400 line-height-18px'>
                            {props.data.content_name}
                        </p>
                        <div className='d-flex justify-content-between gap-3 '>
                            <p className="mb-0 e-alt-font-noto-sans e-text-raisin-black e-font-16 e-font-weight-500 line-height-22px e-ellipse">
                                {props.data.data_name}
                            </p>
                            {props.bannerType !== 3 &&
                                <p className='mb-0 h-100 text-nowrap e-border-bottom-1px-indigo d-flex gap-1 align-items-center e-text-indigo e-alt-font-noto-sans e-font-16 e-font-weight-600 line-height-24px cursor-pointer'
                                    onClick={props.handleAddToArchive}>
                                    <Icon icon={props.data.is_archived === false ? "eye-hide-icon" : "show-eye-icon"}
                                        className='cursor-pointer'
                                        size="24px" />
                                    {props.data.is_archived === false ? "Archive" : "Unarchive"}
                                </p>
                            }
                        </div>
                    </>
                    :
                    <>
                        <p className='mb-3 e-alt-font-noto-sans e-text-raisin-black e-font-14 e-font-weight-400 line-height-18px'>
                            Created link
                        </p>
                        <p className='mb-0 e-alt-font-noto-sans e-text-raisin-black e-font-16 e-font-weight-400 line-height-24px'>
                            <div className='d-flex justify-content-between gap-3'>
                                {props.data.url ?
                                    <a href={props.data.url} target='_blank'
                                        className='e-text-raisin-black text-decoration-none text-decoration-hover-underline text-truncate'>
                                        {props.data.url}
                                    </a>
                                    :
                                    '-'
                                }
                                {props.bannerType !== 3 &&
                                    <span className='text-nowrap e-border-bottom-1px-indigo d-flex gap-1 align-items-center e-text-indigo e-alt-font-noto-sans e-font-16 e-font-weight-600 line-height-24px cursor-pointer'
                                        onClick={props.handleAddToArchive}>
                                        <Icon icon={props.data.is_archived === false ? "eye-hide-icon" : "show-eye-icon"}
                                            className='cursor-pointer'
                                            size="24px" />
                                        {props.data.is_archived === false ? "Archive" : "Unarchive"}
                                    </span>
                                }
                            </div>
                        </p>
                    </>
                }


                {(props.bannerType === 1 || props.bannerType === 2) &&
                    <div className='mt-3 d-flex gap-3 align-items-center'>
                        <SecondaryButton name={props.data.is_active ? "De-activate" : "Activate"}
                            className="e-bg-white e-border-radius-16"
                            onPress={props.handleHideAndShowBanner} />

                        <SecondaryButton name="Edit"
                            className="e-bg-white e-border-radius-16"
                            onPress={props.handleEdit} />
                    </div>
                }

                {/* {props.bannerType === 2 &&
                    <div className='mt-3 d-flex gap-3 align-items-center'>
                        <SecondaryButton name="Edit"
                            className="e-border-radius-16"
                            onPress={props.handleEdit} />
                        <span className='text-nowrap e-border-bottom-1px-indigo d-flex gap-1 align-items-center e-text-indigo e-alt-font-noto-sans e-font-16 e-font-weight-600 line-height-24px cursor-pointer'
                            onClick={props.handleHideAndShowBanner}>
                            <Icon icon={props.bannerType !== 2 ? "eye-hide-icon" : "show-eye-icon"}
                                className='cursor-pointer'
                                size="24px" />
                            {props.bannerType !== 2 ? "Hide banner" : "Show banner"}
                        </span>
                    </div>
                } */}
                {props.bannerType === 3 &&
                    <div className='mt-3 d-flex gap-3 align-items-center'>
                        <SecondaryButton name="Unarchive & activate"
                            className="e-bg-white e-border-radius-16"
                            onPress={props.handleRemoveArchived} />
                        <SecondaryButton name="Edit"
                            className="e-bg-white e-border-radius-16"
                            onPress={props.handleEdit} />
                        <SecondaryButton name="Delete"
                            className="e-bg-white e-border-radius-16"
                            onPress={props.handleDelete} />
                    </div>
                }

                {props.bannerType === 4 &&
                    <div className='mt-3 d-flex gap-3 align-items-center'>
                        <p className="mb-0 e-alt-font-noto-sans e-text-raisin-black e-font-14 e-font-weight-500 line-height-18px">
                            Scheduled for {props.data.scheduled_date || "-"}, {moment(props.data.scheduled_time, "HH:mm:ss").format("hh:mm:ss A")}
                        </p>
                        <SecondaryButton name="Edit"
                            className="e-bg-white e-border-radius-16"
                            onPress={props.handleEdit} />
                    </div>
                }
            </div>
        </div>
    )
}

export default memo(BannerCard);